export default el => {
	const box = el.querySelector('.js-lang-selector-box');

	el.addEventListener('click', () => {
		const status = el.classList.contains('active');

		if (!status) {
			open();
			return;
		}

		close();
	})

	document.addEventListener('click', (e) => {
		if (!el.contains(e.target)) {
			close();
		}	
	})

	const open = () => {
		el.classList.add('active');
	}

	const close = () => {
		el.classList.remove('active');
	}
};
